/**
 * File: useRemindersQueries.ts
 * Path: apps/admin/src/features/today/hooks/useRemindersQueries.ts
 * Description: Today's client payment reminders, prepared by the server
 * (invoiceReminders.ts) for Liam to send with one tap. Read only by people
 * who see the books and may send (finance and sales); everyone else gets
 * none. Read again after every tap (the key sits under the send log's).
 */
import { useQuery } from "@tanstack/react-query";
import type { ReminderProposal } from "@idk/config";
import { useRole } from "@/modules/auth/hooks/useRoleQueries";
import { invoiceSending } from "@/shared/services/invoiceSendingService";
import { remindersKey } from "@/shared/hooks/useInvoiceSendingMutations";

const NONE: readonly ReminderProposal[] = [];

export const useReminders = (): readonly ReminderProposal[] => {
  const { can } = useRole();
  const enabled = can("finance") && can("sales");
  const query = useQuery({
    queryKey: remindersKey,
    queryFn: async () => (await invoiceSending({ action: "reminders" })).proposals ?? [],
    enabled,
    staleTime: 60_000,
  });
  return enabled ? (query.data ?? NONE) : NONE;
};
